/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '../../actions.constants';
import { storeMutations } from '../../mutations.constants';

const userActions = {
  [storeActions.addLicenseManager]: ({ commit }, payLoad) => {
    return httpClient.post('/user/create', payLoad).then(
      (res) => {
        // commit(storeMutations.licenseManagerMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.licenseManagerMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getLicenseManagerDetails]: ({ commit }, payLoad) => {
    let url=`/user/list?page=${payLoad.page}&limit=${payLoad.limit}`
    if(payLoad.sort) url+=`&sort={"${payLoad.sort}":"${payLoad.desc?-1:1}"}`
    if(payLoad.search)url+=`&search=${payLoad.search}`
    if(payLoad.id)url+=`&filter={"role_name":"${payLoad.id}"}`
    return httpClient
      .get(url)
      .then(
        (res) => {
          commit(storeMutations.licenseManagerMutation, res);
          return res;
        },
        (err) => {
          commit(storeMutations.licenseManagerMutation, err);
          return err.response;
        },
      );
  },
  [storeActions.getLicenseManagerById]: ({ commit }, payLoad) => {
    return httpClient
      .get('/user/getUserDetailsById/' + payLoad.customer_id)
      .then(
        (res) => {
          // commit(storeMutations.licenseMutation, res);
          return res;
        },
        (err) => {
          // commit(storeMutations.licenseMutation, err);
          return err.response;
        },
      );
  },
  [storeActions.updateLicenseManager]: ({ commit }, payLoad) => {
    return httpClient.post('/user/update/' + payLoad.user_id, payLoad).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getRoleList]: ({ commit }, payLoad) => {
    return httpClient.get('/user/getRoleList', payLoad).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getUserCount]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.get(`/user/getUserCount`, payLoad).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
};
export default { ...userActions };
